// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetInitialHoklaRequestRequestModel from '../../model/get-initial-hokla-request-request-model';
import GetInitialHoklaRequestRequestDTO from '../dto/get-initial-hokla-request-request-dto';
import dtoSchema from '../schemas/get-initial-hokla-request-request-schema';

export default abstract class GetInitialHoklaRequestRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetInitialHoklaRequestRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetInitialHoklaRequestRequestDTO>): GetInitialHoklaRequestRequestModel;
  static toModel(dto: DeepPartial<GetInitialHoklaRequestRequestDTO> | undefined | null): GetInitialHoklaRequestRequestModel | undefined;
  static toModel(dto: DeepPartial<GetInitialHoklaRequestRequestDTO> | undefined | null): GetInitialHoklaRequestRequestModel | undefined {
    return dto ? new GetInitialHoklaRequestRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetInitialHoklaRequestRequestModel> | GetInitialHoklaRequestRequestModel): GetInitialHoklaRequestRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetInitialHoklaRequestRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetInitialHoklaRequestRequestModel, can not map to GetInitialHoklaRequestRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
